import * as React from 'react';
import ContentLoader from 'react-content-loader';
const Line = (props) => (React.createElement(ContentLoader, { viewBox: "0 0 200 30", height: 30, width: 200, ...props },
    React.createElement("rect", { x: "0", y: "0", rx: "3", ry: "3", width: "250", height: "10" })));
export default Line;
//# sourceMappingURL=title-loader.js.map